import { render, staticRenderFns } from "./navigationMobile.vue?vue&type=template&id=c5233c66"
import script from "./navigationMobile.vue?vue&type=script&lang=js"
export * from "./navigationMobile.vue?vue&type=script&lang=js"
import style0 from "./navigationMobile.vue?vue&type=style&index=0&id=c5233c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports